/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewPrivacyStatusEnum = {
    LoadFailure: 'load_failure',
    ParseFailure: 'parse_failure',
    Blocked: 'blocked',
    Success: 'success',
    ContentTooLarge: 'content_too_large',
    SkippedPolicy: 'skipped_policy',
    InvalidDomain: 'invalid_domain'
} as const;
export type CRSFSecReviewPrivacyStatusEnum = typeof CRSFSecReviewPrivacyStatusEnum[keyof typeof CRSFSecReviewPrivacyStatusEnum];


export function CRSFSecReviewPrivacyStatusEnumFromJSON(json: any): CRSFSecReviewPrivacyStatusEnum {
    return CRSFSecReviewPrivacyStatusEnumFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyStatusEnum {
    return json as CRSFSecReviewPrivacyStatusEnum;
}

export function CRSFSecReviewPrivacyStatusEnumToJSON(value?: CRSFSecReviewPrivacyStatusEnum | null): any {
    return value as any;
}

